import { useEffect } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"

import ListSuppliers from "./ListSuppliers.js"
import ViewSupplier from "./ViewSupplier.js"
import CreateSupplier from "./CreateSupplier.js"
import EditSupplier from "./EditSupplier.js"




export default function Suppliers() {

    return (
        <Routes>
            <Route path="/" element={<ListSuppliers />} />
            <Route path="/view/:id" element={<ViewSupplier />} />
            <Route path="/edit/:id" element={<EditSupplier />} />
            <Route path="/create/" element={<CreateSupplier />} />
        </Routes>
    )
}


